interface StarRatingProps {
  value: number;
  size?: "sm" | "md";
  showValue?: boolean;
}

export default function StarRating({ value, size = "sm", showValue = true }: StarRatingProps) {
  const full = Math.floor(value);
  const hasHalf = value - full >= 0.5;
  const iconSize = size === "sm" ? "text-[11px]" : "text-sm";

  return (
    <div className="flex items-center gap-1">
      <div className="flex items-center text-secondary-500">
        {Array.from({ length: 5 }).map((_, index) => {
          if (index < full) {
            return <i key={index} className={`ri-star-fill ${iconSize}`}></i>;
          }
          if (index === full && hasHalf) {
            return <i key={index} className={`ri-star-half-fill ${iconSize}`}></i>;
          }
          return <i key={index} className={`ri-star-line ${iconSize} text-background-400`}></i>;
        })}
      </div>
      {showValue && (
        <span className={`${iconSize} font-semibold text-secondary-700`}>
          {value.toFixed(1)}
        </span>
      )}
    </div>
  );
}